export function findScrollableAncestor(el: HTMLElement): HTMLElement | null {
  if (typeof window === 'undefined' || typeof getComputedStyle !== 'function') {
    return null;
  }

  let container: HTMLElement | null = el.parentElement;
  while (container) {
    const overflowY = getComputedStyle(container).overflowY;
    if (
      (overflowY === 'auto' || overflowY === 'scroll') &&
      container.scrollHeight > container.clientHeight
    ) {
      return container;
    }
    container = container.parentElement;
  }

  return null;
}

// A native `scrollIntoView` mis-targets when a transformed / will-change ancestor sits in between
// (the mobile task modal stack), so the delta comes from viewport-relative rects.
export function scrollElementIntoView(
  el: HTMLElement,
  options?: ScrollIntoViewOptions
): void {
  const container = findScrollableAncestor(el);
  if (!container) {
    el.scrollIntoView(options);
    return;
  }

  const inset = parseFloat(getComputedStyle(el).scrollMarginBottom) || 0;
  const targetTop =
    container.scrollTop +
    (el.getBoundingClientRect().bottom -
      container.getBoundingClientRect().bottom) +
    inset;
  const behavior: ScrollBehavior = options?.behavior ?? 'auto';

  if (typeof container.scrollTo === 'function') {
    container.scrollTo({ top: targetTop, behavior });
  } else {
    container.scrollTop = targetTop;
  }
}

export function prefersReducedMotion(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  );
}
